var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4774 10.8158H5.66406",
    stroke: "#FF0909",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4774 8.02474H5.66406",
    stroke: "#FF0909",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50073 5.24154H5.66406",
    stroke: "#FF0909",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6058 1.83398C10.6058 1.83398 5.48782 1.83665 5.47982 1.83665C3.63982 1.84798 2.50049 3.05865 2.50049 4.90532V11.036C2.50049 12.892 3.64849 14.1073 5.50449 14.1073C5.50449 14.1073 10.6218 14.1053 10.6305 14.1053C12.4705 14.094 13.6105 12.8827 13.6105 11.036V4.90532C13.6105 3.04932 12.4618 1.83398 10.6058 1.83398Z",
    stroke: "#FF0909",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentRed);
export default __webpack_public_path__ + "static/media/document-red.1e205120d7e029de99047cbef217be92.svg";
export { ForwardRef as ReactComponent };